import $ from 'jquery';
import anime from 'animejs';
import PubSub from 'pubsub-js';
import Page from 'js/lib/page';

export default class Header extends Page {
  init() {
    this.$.body = $('.js-body');
    if (this.$.body.is('.is-hide-fixed-header')) return;

    this.state = {
      fixed: false,
      prevScroll: this.$.window.scrollTop(),
      animating: false
    };

    this.param = {
      height: this.$.root.outerHeight(),
      offset: this.$.root.outerHeight() * 4
    };

    this.events();
  }
  events() {
    this.$.window.on('wheel', e => this.scrollHandler(e));
    this.$.document.ready(e => this.ready());
  }
  ready() {
    if (this.$.window.scrollTop() > this.param.offset) {
      setTimeout(() => {
        this.fix();
      }, 1000);
    }
  }
  scrollHandler(e) {
    if (this.state.animating) return;

    const direction = this.getDirection(e);

    if (this.readyToFixed(direction)) {
      this.fix();
    }

    if (this.readyToUnfixed(direction)) {
      this.unfix();
    }
  }
  fix() {
    this.$.root.addClass('is-fixed');

    this.$.body.css({
      paddingTop: `${this.param.height}px`
    });

    const height = this.$.root.outerHeight();

    this.state.animating = true;
    this.$.root.css({
      transform: `translateY(${height * -1}px)`
    });

    anime({
      targets: this.$.root.get(0),
      duration: 400,
      translateY: 0,
      easing: 'easeInOutQuad',
      complete: () => {
        this.state.animating = false;
        this.state.fixed = true;

        PubSub.publish('header.fixed', {});
      }
    });
  }
  unfix() {
    this.state.animating = true;

    const height = this.$.root.outerHeight();

    anime({
      targets: this.$.root.get(0),
      duration: 200,
      translateY: height * -1,
      easing: 'easeInOutQuad',
      complete: () => {
        this.$.root.removeClass('is-fixed');
        this.$.root.removeAttr('style');

        this.state.fixed = false;
        this.state.animating = false;

        this.$.body.removeAttr('style');

        PubSub.publish('header.unfixed', {});
      }
    });
  }
  readyToFixed(direction) {
    const offset = this.$.window.scrollTop() > this.param.offset;
    const dir = direction === 'DOWN';
    const fixed = !this.state.fixed;

    return dir && offset && fixed;
  }
  readyToUnfixed(direction) {
    const offset = this.$.window.scrollTop() < this.param.offset * 3;
    const dir = direction === 'UP';
    const fixed = this.state.fixed;

    return dir && offset && fixed;
  }
  getDirection(e) {
    const scrolled = this.$.window.scrollTop();
    const direction = scrolled < this.state.prevScroll ? 'UP' : 'DOWN';

    this.state.prevScroll = scrolled;

    return direction;
  }
}

Page.make(Header, '.js-header');
